import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { allProducts, categoryOf } from '../../data/catalog';

export const RelatedProducts = ({ currentId }) => {
  const cat = categoryOf(currentId);
  const sameCategory = allProducts.filter((p) => p.id !== currentId && categoryOf(p.id) === cat);
  const others = allProducts.filter((p) => p.id !== currentId && categoryOf(p.id) !== cat);
  const related = [...sameCategory, ...others].slice(0, 4);

  return (
    <section className="py-16 bg-white" data-testid="related-products-section">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center">Related Machinery</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {related.map((p) => (
            <Link key={p.id} to={`/products/${p.slug}`} data-testid={`related-product-${p.slug}`}>
              <Card className="border-2 border-gray-200 hover:border-alden-green hover:shadow-xl transition-all h-full group overflow-hidden">
                <div className="h-40 overflow-hidden">
                  <img
                    src={p.heroImage}
                    alt={`${p.title} by Alden Technologies`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <CardContent className="p-5">
                  <h3 className="font-bold text-gray-900 mb-1 group-hover:text-alden-green transition-colors">{p.title}</h3>
                  <p className="text-sm text-alden-green font-semibold mb-3">{p.price?.range}</p>
                  <span className="inline-flex items-center gap-1 text-sm text-gray-600 group-hover:text-alden-green">
                    View Details <ArrowRight className="w-4 h-4" />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
